// @flow

import * as React from 'react';

import { useNavigate } from 'react-router-dom';

import { useRequireAuthLink } from '@gandi/authentication';

import { redirectTo } from '../helpers';

export function useRequireAuthNavigate(path: string): () => void {
  const navigate = useNavigate();
  const linkProps = useRequireAuthLink(path);

  return React.useCallback(() => {
    if (linkProps.to) {
      navigate(linkProps.to);
    } else if (linkProps.href && typeof window !== 'undefined') {
      redirectTo(linkProps.href);
    }
  }, [linkProps, navigate]);
}
